import _ from 'lodash';
import Element from './Element';
import mixin from '../privates/utils/mixin';
import { isNilOrEmptyString} from '../privates/utils';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import ClickableMixin from './mixins/ClickableMixin';
import * as members from '../privates/privateMembers';
import LinkableMixin from './mixins/LinkableMixin';
import imageUtils from '../privates/utils/imageUtils';
import {validate} from '../privates/validations/validation';
import {IMAGE_CLICK_ACTIONS} from '../privates/constants';

class BaseImage extends Element {
    validateAlt(value) {
        const compType = members._type.get(this).compType;
        const isValid = validate({
            compType,
            functionName: 'alt',
            dataToValidate: {alt: value},
            compName: this.id
        });
        return isValid;
    }

    prepareSrc(value) {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const compData = RMI.getFullDataWithOverrides(compId);
        const compType = members._type.get(this).compType;
        const isValid = validate({
            compType,
            functionName: 'src',
            dataToValidate: {src: value},
            compName: this.id
        });
        if (!isValid) {
            return;
        }

        let imageData;
        if (isNilOrEmptyString(value)) {
            imageData = {uri: ''};
        } else{
            imageData = imageUtils.convertImageToModelFormatAndReportIfError(value, 'src', 'src');
            if (!imageData){
                return;
            }
        }

        // In the case of an external url, the viewer will update the image's original height and width on image load
        // To avoid flickering, we are keeping the previous width and height
        if (imageData.uri) {
            if (!imageData.width) {
                imageData.width = compData.width;
            }
            if (!imageData.height) {
                imageData.height = compData.height;
            }
        }

        imageData.crop = null;
        return imageData;
    }

    getClickAction() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const clickAction = RMI.getProps(compId).onClickBehavior;
        return _.findKey(IMAGE_CLICK_ACTIONS, (v) => v === clickAction);
    }

    setClickAction(action) {
        const compType = members._type.get(this).compType;
        const isValid = validate({
            compType,
            functionName: 'clickAction',
            dataToValidate: {clickAction: action},
            compName: this.id
        });

        if (!isValid) {
            return;
        }

        const clickAction = _.isNil(action) ? IMAGE_CLICK_ACTIONS.none : IMAGE_CLICK_ACTIONS[action];

        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        RMI.setProps(compId, {onClickBehavior: clickAction});
    }

}

mixin(BaseImage.prototype, HiddenCollapsedMixin.prototype);
mixin(BaseImage.prototype, LinkableMixin.prototype);
mixin(BaseImage.prototype, ClickableMixin.prototype);

export default BaseImage;
